import { DownloadIcon, WriteIcon } from "@xola/icons";
import React from "react";
import { Waiver } from "types";
import { getWaiverFileName, getWaiverUrl } from "../../../../../models/Waiver";
import { openAuthenticatedUrl } from "../../../../../utils/url";
import { SecondaryButton } from "../../../../Common/SecondaryButton";
import { TimelineItem } from "../../../../PurchasesMenu/Timeline/TimelineItem";

interface WaiverTimelineItemProps {
    change: Waiver;
    showDate?: boolean;
}

export const WaiverTimelineItem = ({ change: waiver, showDate = false }: WaiverTimelineItemProps) => {
    const audit = {
        createdAt: waiver.createdAt,
        createdBy: waiver.createdBy,
    };

    const handleDownloadButtonClick = () => {
        openAuthenticatedUrl(getWaiverUrl(waiver), getWaiverFileName(waiver));
    };

    return (
        <TimelineItem title="Waiver Signed" audit={audit} icon={<WriteIcon />} color="primary" showDate={showDate}>
            <div className="flex flex-col">
                <WaiverSignedFor waiver={waiver} />
                <div className="font-bold">
                    <SecondaryButton size="tiny" className="py-2 px-3" onClick={handleDownloadButtonClick}>
                        <DownloadIcon size="tiny" /> <span className="ml-2">Download</span>
                    </SecondaryButton>
                </div>
            </div>
        </TimelineItem>
    );
};

WaiverTimelineItem.supportsAudit = (waiver: Waiver) => {
    return !!waiver?.remoteId;
};

export const WaiverSignedFor = ({ waiver }: { waiver: Waiver }) => {
    return (
        <div>
            Waiver signed for{" "}
            <var data-var="participants">
                {waiver.participants.map((participant) => participant.customerName).join(", ")}
            </var>
        </div>
    );
};
